import { Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { Home } from '@/pages/Home';
import { Producto } from '@/pages/Producto';
import { Jurisdicciones } from '@/pages/Jurisdicciones';
import { Metodo } from '@/pages/Metodo';
import { Mcp } from '@/pages/Mcp';
import { Docentes } from '@/pages/audiences/Docentes';
import { Directivos } from '@/pages/audiences/Directivos';
import { Especialistas } from '@/pages/audiences/Especialistas';
import { Desarrolladores } from '@/pages/audiences/Desarrolladores';
import { Glosario } from '@/pages/Glosario';
import { Sobre } from '@/pages/Sobre';
import { Contacto } from '@/pages/Contacto';
import { Legal } from '@/pages/Legal';
import { NotFound } from '@/pages/NotFound';

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="producto">
          <Route index element={<Producto />} />
          <Route path="jurisdicciones" element={<Jurisdicciones />} />
          <Route path="metodo" element={<Metodo />} />
          <Route path="mcp" element={<Mcp />} />
        </Route>
        <Route path="audiencias">
          <Route path="docentes" element={<Docentes />} />
          <Route path="directivos" element={<Directivos />} />
          <Route path="especialistas" element={<Especialistas />} />
          <Route path="desarrolladores" element={<Desarrolladores />} />
        </Route>
        <Route path="glosario" element={<Glosario />} />
        <Route path="sobre" element={<Sobre />} />
        <Route path="contacto" element={<Contacto />} />
        <Route path="legal" element={<Legal />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
